import { connect } from 'react-redux';
import type { ValuationPBRatioProps } from '@/pages/CompanyReport/components/Value';
import { ValuationPBRatioRawData } from '@/pages/CompanyReport/components/Value';
import {
  getSummary,
  getAnalysis,
  getFormatting,
} from '@/pages/CompanyReport/redux/selectors';
import { getAveragesSelector } from '@ducks/averages/selectors';

const mapStateToProps = (
  state,
  ownProps: { companyId?: string }
): ValuationPBRatioProps => {
  const summary = getSummary(state, ownProps);
  const analysis = getAnalysis(state, ownProps);
  const formatting = getFormatting(state, ownProps);
  const { getIndustryAverage, getMarketAverage } = getAveragesSelector(
    state,
    ownProps
  );

  const industryPB = getIndustryAverage('PB');
  const marketPB = getMarketAverage('PB');
  return {
    uniqueSymbol: summary.uniqueSymbol,
    lastEarningsUpdate: analysis.lastEarningsUpdateTimeStamp,
    reportingCurrencyISO: formatting.reportingCurrencyISO,
    pbValue: analysis.PB,
    bookValuePerShare: analysis.bookValuePerShare,
    reportingCurrencySymbol: formatting.reportingCurrencySymbol,
    exchangeSymbol: summary.exchangeSymbol,
    tickerSymbol: summary.tickerSymbol,
    latestPriceDate: analysis.eodPriceUpdateTimeStamp,
    primaryTradingCurrencySymbol: formatting.primaryTradingItemCurrencySymbol,
    primaryTradingCurrencyISO: formatting.primaryTradingItemCurrencyISO,
    primaryPrice: analysis.primaryPrice,
    primaryCurrencyReported: analysis.primaryCurrencyReported,
    isExchangeRateNeeded: formatting.isExchangeRateNeeded,
    exchangeRate: formatting.exchangeRate,
    industryCountryName: industryPB.source,
    industrySecondaryName: summary.industryData.secondaryName,
    industryAveragePBCount: industryPB.count,
    industryAveragePB: industryPB.value,
    marketCountryName: marketPB.source,
    marketAveragePBCount: marketPB.count,
    marketAveragePB: marketPB.value,
    companyShortName: summary.shortName,
  };
};

export default connect(mapStateToProps)(ValuationPBRatioRawData);
